import { render, staticRenderFns } from "./enrichment-details.vue?vue&type=template&id=06244d60&scoped=true&"
import script from "./enrichment-details.vue?vue&type=script&lang=js&"
export * from "./enrichment-details.vue?vue&type=script&lang=js&"
import style0 from "./enrichment-details.vue?vue&type=style&index=0&id=06244d60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06244d60",
  null
  
)

export default component.exports